import { combineReducers } from 'redux-immutablejs';
import globalReducer from './global';
import presentationReducer from './presentation';
import propertyReducer from './property';
import masterReducer from './master';
import regressionReducer from './regression';
import versionReducer from './version';
import dashboardReducer from './dashboard';
import modalReducer from './modal';
import dataloadReducer from './dataload';
import configurationsReducer from './configurations';
/**
 * The application's main reducer
 */
export default combineReducers({
  configurations: configurationsReducer,
  dashboard: dashboardReducer,
  dataload: dataloadReducer,
  global: globalReducer,
  master: masterReducer,
  modal: modalReducer,
  presentation: presentationReducer,
  property: propertyReducer,
  regression: regressionReducer,
  version: versionReducer,
});
